import React, { useState } from 'react';
import { IoSearchCircle } from 'react-icons/io5';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { searchProductos } from '../../actions/home';
import { useNavigate } from 'react-router-dom';

export const SearchAutocomplete = () => {
  const [items, setItems] = useState([]);
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [isTyping, setIsTyping] = useState(false);
  const navigate = useNavigate();

  const handleOnSearch = async (string) => {
    if (string.length > 0) {
      setShowSearchIcon(false);
      setIsTyping(true);
    } else {
      setShowSearchIcon(true);
      setIsTyping(false);
    }

    try {
      const results = await searchProductos(string);
      setItems(results.map((producto, index) => ({ id: producto.productoSku, name: producto.productoNombre })));
    } catch (error) {
      console.error('Error al obtener resultados de búsqueda:', error);
    }
  };

  const handleOnHover = (result) => {
    console.log(result);
  };

  const handleOnSelect = (item) => {
    console.log(item);
    navigate(`/detalle-producto/${item.id}`);
  };

  const handleOnFocus = () => {
    console.log('Focused');
  };

  const handleClear = () => {
    setShowSearchIcon(true);
    setIsTyping(false);
  };

  const formatResult = (item) => {
    return (
      <span style={{ display: 'block', textAlign: 'left', cursor: "pointer" }}>{item.name}</span>
    );
  };

  return (
    <div className="width-search position-relative div-nohidden" style={{ zIndex: 9999 }}>
      <ReactSearchAutocomplete
        items={items}
        onSearch={handleOnSearch}
        onHover={handleOnHover}
        onSelect={handleOnSelect}
        onFocus={handleOnFocus}
        onClear={handleClear}
        autoFocus
        formatResult={formatResult}
        className={`input-search font-family-montserrat ${isTyping ? 'typing' : ''}`}
        showIcon={false}
        styling={{
          borderRadius: isTyping ? "20px" : "30px",
          height: "36px",
          color: "black !important",
          fontWeight: 500,
          paddingLeft: "10px",
          paddingRight: "10px",
          boxSizing: "unset !important",
          fontFamily: "Montserrat",
          fontSize: "14px",
          transition: "border-radius 0.3s ease",
          clearIconMargin: "0px 10px 0px 0px",
          searchIconMargin: "0px 10px 0px 0px",
          searchIconVisibility: "hidden",
          resultsContainer: {
            padding: "30px 10px !important"
          }
        }}
        placeholder="Busca tu producto favorito"
        showNoResultsText="No se encuentran resultados"
      />
      {showSearchIcon && (
        <IoSearchCircle
          className="icon-search-sm position-absolute"
          size={35}
          color="#27D309"
          style={{ transition: 'opacity 0.3s ease', opacity: showSearchIcon ? 1 : 0 }}
        />
      )}
    </div>
  );
}